import { useShallow } from 'zustand/shallow';

import type { EntityType } from '@/core/graphql/generated/types';

import { useDcrModalStore } from './dcrModalStore';

export const useOpenDcrModal = () =>
	useDcrModalStore(useShallow(({ open }) => open));

export const useDcrModalState = () =>
	useDcrModalStore(
		useShallow(({ entityType, isOpen, mountKey }) => ({
			entityType,
			isOpen,
			mountKey
		}))
	);

export const useDcrModalActions = () =>
	useDcrModalStore(
		useShallow(({ close, exited, setLoaded }) => ({ close, exited, setLoaded }))
	);

export const useIsDcrModalLoading = (entityType?: EntityType) =>
	useDcrModalStore(
		({ isLoading, entityType: activeEntityType }) =>
			isLoading && (entityType === undefined || activeEntityType === entityType)
	);
